module.exports = __webpack_public_path__ + "img/u2212.17538752.svg";